import React, { useEffect, useState } from "react";
import "./SeniorStudents.scss";
import axios from "axios";

import { utils, writeFile } from "xlsx";
import { DateRangePicker } from "rsuite";
import { Input, SelectPicker } from "rsuite";

import Button from "../../components/Button/Button";
import Loader from "../../components/Loader/Loader";
import EntranceTable from "../../components/EntranceTable/EntranceTable";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// Icons
import {
  FaUsers,
  FaGraduationCap,
  FaSearch,
  FaFilter,
  FaDownload,
  FaSchool,
  FaCalendarAlt,
  FaHome,
  FaUtensils,
  FaBus,
  FaBed,
  FaExclamationTriangle,
  FaFileExcel,
  FaListAlt,
  FaChartBar,
  FaInfoCircle,
  FaDatabase,
  FaUserGraduate,
  FaBookOpen,
} from "react-icons/fa";

const BE_URL = process.env.REACT_APP_API_BASE_URL;

const SeniorStudents = ({ is_Senior }) => {
  const location = useLocation();

  useEffect(() => {
    fetchStudents();
  }, [location]);

  //RBAC code block
  const allPermissions = useSelector((state) => state.permissions);
  let permissions = null;
  if (is_Senior) {
    permissions = allPermissions
      .find((p) => p.name === "Students")
      ?.dropdowns.find((dd) => dd.name === "Senior Students")?.permissions;
  } else {
    permissions = allPermissions
      .find((p) => p.name === "Students")
      ?.dropdowns.find((dd) => dd.name === "Junior Students")?.permissions;
  }

  const [sortOrder, setSortOrder] = useState("desc");
  const hostelOptions = ["All", "Yes", "No"];

  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [branch, setBranch] = useState("Baramati");
  const [isLoading, setIsLoading] = useState(true);
  const [cancelled, setcancelled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [hostelFilter, setHostelFilter] = useState("All");
  const [messFilter, setmessFilter] = useState("All");
  const [transportFilter, settransportFilter] = useState("All");
  const [hostelAllocatedFilter, setHostelAllocatedFilter] = useState("All");
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSession, setSelectedSession] = useState("2025-2026");

  const sessionOptions = ["2024-2025", "2025-2026", "2026-2027", "All"];
  const branches = ["Baramati", "Pune", "Nagar", "Ranchi"];

  const classOptions = [
    "All Classes",
    "Class 6th",
    "Class 7th",
    "Class 8th",
    "Class 9th",
    "Class 10th",
    "Class 11th",
    "Class 12th",
    "Neet Repeater",
    "JEE Repeater",
  ];

  const classData = classOptions.map((cls) => ({
    label: cls,
    value: cls,
    role: cls === "All Classes" ? "All" : "Class",
  }));

  const handleDateRangeChange = (item) => {
    if (!item) {
      setDateRange([]);
    } else {
      setDateRange(item);
    }
  };

  const fetchStudents = async () => {
    setIsLoading(true);
    try {
      const tokens = JSON.parse(localStorage.getItem("ERPTokens"));
      console.log("Is senior is ", is_Senior);
      const url = is_Senior
        ? `${BE_URL}/api/students?senior=${is_Senior}&is_cancelled=${cancelled}&session=${selectedSession}&branch=${branch}`
        : `${BE_URL}/api/students/junior?senior=${is_Senior}&is_cancelled=${cancelled}&session=${selectedSession}&branch=${branch}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokens.accessToken}` },
      });
      setStudents(null);
      setStudents(response.data);
      setFilteredStudents([]);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        const newTokens = await refreshToken();
        if (newTokens) {
          fetchStudents(is_Senior);
        } else {
          // Handle failed refresh token scenario
        }
      } else {
        console.error("Error fetching students:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClasses = async () => {
    try {
      const tokens = JSON.parse(localStorage.getItem("ERPTokens"));
      const response = await axios.get(`${BE_URL}/api/classes`, {
        headers: { Authorization: `Bearer ${tokens.accessToken}` },
      });
      const classOptions = [
        { label: "All Classes", value: "" },
        ...response.data.map((cls) => ({
          label: cls.class_name,
          value: cls.class_name,
        })),
      ];
      setClasses(classOptions);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const refreshToken = async () => {
    try {
      const tokens = JSON.parse(localStorage.getItem("ERPTokens"));
      const response = await axios.post(`${BE_URL}/refreshToken`, {
        refreshToken: tokens.refreshToken,
      });
      if (response.data.accessToken) {
        localStorage.setItem("ERPTokens", JSON.stringify(response.data));
        return response.data;
      } else {
        throw new Error("Failed to refresh token.");
      }
    } catch (error) {
      console.error("Error refreshing token:", error);
      return null;
    }
  };

  useEffect(() => {
    fetchStudents();
    fetchClasses();
  }, []);

  useEffect(() => {
    fetchStudents();
  }, [cancelled, selectedSession, branch]);

  useEffect(() => {
    applyFilters();
  }, [
    searchTerm,
    dateRange,
    selectedClass,
    hostelFilter,
    hostelAllocatedFilter,
    students,
    messFilter,
    transportFilter,
  ]);

  const applyFilters = () => {
    let filtered = students.filter((student) => {
      const matchesSearchTerm = searchTerm
        ? student.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.middle_name
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          student.last_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.roll_no.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.prev_roll_no
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          student.aadhar.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.whatsapp.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.email.toLowerCase().includes(searchTerm.toLowerCase())
        : true;

      const matchesClass = selectedClass
        ? student.adm_class.toString() === selectedClass.toString()
        : true;
      const matchesHostel =
        hostelFilter !== "All"
          ? hostelFilter === "Yes"
            ? student.hostel
            : !student.hostel
          : true;

      const matchesMess =
        messFilter !== "All"
          ? messFilter === "Yes"
            ? student.mess
            : !student.mess
          : true;
      const matchesTransport =
        transportFilter !== "All"
          ? transportFilter === "Yes"
            ? student.transport
            : !student.transport
          : true;
      const matchesHostelAllocated =
        hostelAllocatedFilter !== "All"
          ? hostelAllocatedFilter === "Yes"
            ? student.bed_id != null
            : student.bed_id == null
          : true;

      return (
        matchesSearchTerm &&
        matchesClass &&
        matchesHostel &&
        matchesHostelAllocated &&
        matchesMess &&
        matchesTransport
      );
    });

    setFilteredStudents(filtered);
  };

  useEffect(() => {
    setIsLoading(true);
    if (sortOrder === "desc") {
      setStudents((prevstudents) =>
        [...prevstudents].sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        )
      );
    } else {
      setStudents((prevstudents) =>
        [...prevstudents].sort(
          (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
        )
      );
    }
    setIsLoading(false);
  }, [sortOrder]);

  const handleClassFilterChange = (value) => {
    setSelectedClass(value);
    console.log("selected class is ", value);
  };

  const downloadExcel = () => {
    setIsLoading(true);
    const ws = utils.json_to_sheet(filteredStudents);
    const wb = utils.book_new();
    if (is_Senior) {
      utils.book_append_sheet(wb, ws, "SeniorStudents");
      writeFile(wb, "SeniorStudents.xlsx");
    } else {
      utils.book_append_sheet(wb, ws, "JuniorStudents");
      writeFile(wb, "JuniorStudents.xlsx");
    }
    setIsLoading(false);
  };

  // Calculate statistics
  const getStatistics = () => {
    const hostelStudents = filteredStudents.filter(
      (student) => student.hostel
    ).length;
    const messStudents = filteredStudents.filter(
      (student) => student.mess
    ).length;
    const transportStudents = filteredStudents.filter(
      (student) => student.transport
    ).length;
    const allocatedHostel = filteredStudents.filter(
      (student) => student.bed_id != null
    ).length;

    return {
      total: filteredStudents.length,
      hostel: hostelStudents,
      mess: messStudents,
      transport: transportStudents,
      allocated: allocatedHostel,
    };
  };

  const stats = getStatistics();

  return (
    <div className="senior-students-container">
      {permissions?.can_read ? (
        <>
          {/* Header Section */}
          <div className="senior-students-header">
            <div className="senior-students-header-left">
              <div className="senior-students-header-icon">
                {is_Senior ? <FaUserGraduate /> : <FaBookOpen />}
              </div>
              <div className="senior-students-header-content">
                <h1 className="senior-students-title">
                  {is_Senior ? "Senior" : "Junior"} Students Management
                </h1>
                <p className="senior-students-subtitle">
                  Comprehensive student data management and analytics
                </p>
              </div>
            </div>
            <div className="senior-students-header-right">
              <div className="senior-students-actions">
                <button
                  className="action-btn excel-btn"
                  onClick={downloadExcel}
                  disabled={filteredStudents.length === 0}
                >
                  <FaFileExcel />
                  <span>Export Excel</span>
                </button>
                <button
                  className={`action-btn toggle-btn ${
                    cancelled ? "active" : ""
                  }`}
                  onClick={() => setcancelled(!cancelled)}
                >
                  <FaListAlt />
                  <span>{cancelled ? "Show Active" : "Show Cancelled"}</span>
                </button>
              </div>
            </div>
          </div>

          {/* Statistics Cards */}
          {/* <div className="senior-students-stats">
            <div className="stat-card primary">
              <div className="stat-icon">
                <FaUsers />
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{stats.total}</h3>
                <p className="stat-label">Total Students</p>
              </div>
            </div>
            <div className="stat-card hostel">
              <div className="stat-icon">
                <FaHome />
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{stats.hostel}</h3>
                <p className="stat-label">Hostel Students</p>
              </div>
            </div>
            <div className="stat-card mess">
              <div className="stat-icon">
                <FaUtensils />
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{stats.mess}</h3>
                <p className="stat-label">Mess Students</p>
              </div>
            </div>
            <div className="stat-card transport">
              <div className="stat-icon">
                <FaBus />
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{stats.transport}</h3>
                <p className="stat-label">Transport Students</p>
              </div>
            </div>
            <div className="stat-card allocated">
              <div className="stat-icon">
                <FaBed />
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{stats.allocated}</h3>
                <p className="stat-label">Allocated Beds</p>
              </div>
            </div>
          </div> */}

          {/* Warning Banner for Cancelled List */}
          {cancelled && (
            <div className="warning-banner">
              <FaExclamationTriangle />
              <span>Currently displaying cancelled students list</span>
            </div>
          )}

          {/* Filters Section */}
          <div className="senior-students-filters">
            {/* <div className="filters-header">
              <div className="filters-header-left">
                <FaFilter />
                <h2>Filters & Search</h2>
              </div>
              <div className="filters-header-right">
                <span className="results-count">
                  {filteredStudents.length} of {students.length} students
                </span>
              </div>
            </div> */}

            <div className="filters-grid">
              {/* Search Filter */}
              {/* <div className="filter-group search-group">
                <label className="filter-label">
                  <FaSearch />
                  <span>Search Students</span>
                </label>
                <div className="search-input-wrapper">
                  <FaSearch className="search-icon" />
                  <Input
                    placeholder="Search by name, roll no, aadhar, or phone..."
                    onChange={(event) => setSearchTerm(event)}
                    className="search-input"
                  />
                </div>
              </div> */}

              {/* Branch Filter */}
              <div className="filter-group">
                <label className="filter-label">
                  <FaSchool />
                  <span>Branch</span>
                </label>
                <SelectPicker
                  data={branches.map((opt) => ({ label: opt, value: opt }))}
                  onChange={setBranch}
                  value={branch}
                  cleanable={false}
                  searchable={false}
                  placeholder="Select Branch"
                  className="filter-select"
                />
              </div>

              {/* Session Filter */}
              <div className="filter-group">
                <label className="filter-label">
                  <FaCalendarAlt />
                  <span>Session</span>
                </label>
                <SelectPicker
                  data={sessionOptions.map((opt) => ({
                    label: opt,
                    value: opt,
                  }))}
                  onChange={setSelectedSession}
                  value={selectedSession}
                  cleanable={false}
                  searchable={false}
                  placeholder="Select Session"
                  className="filter-select"
                />
              </div>

              {/* Class Filter */}
              <div className="filter-group">
                <label className="filter-label">
                  <FaGraduationCap />
                  <span>Class</span>
                </label>
                <SelectPicker
                  data={classes}
                  onChange={handleClassFilterChange}
                  value={selectedClass}
                  cleanable={false}
                  searchable={false}
                  placeholder="Select Class"
                  className="filter-select"
                />
              </div>

              {/* Hostel Filter */}
              <div className="filter-group">
                <label className="filter-label">
                  <FaHome />
                  <span>Hostel</span>
                </label>
                <SelectPicker
                  data={hostelOptions.map((opt) => ({
                    label: opt,
                    value: opt,
                  }))}
                  onChange={setHostelFilter}
                  value={hostelFilter}
                  cleanable={false}
                  searchable={false}
                  className="filter-select"
                />
              </div>

              {/* Hostel Allocated Filter */}
              <div className="filter-group">
                <label className="filter-label">
                  <FaBed />
                  <span>Bed Allocated</span>
                </label>
                <SelectPicker
                  data={hostelOptions.map((opt) => ({
                    label: opt,
                    value: opt,
                  }))}
                  onChange={setHostelAllocatedFilter}
                  value={hostelAllocatedFilter}
                  cleanable={false}
                  searchable={false}
                  className="filter-select"
                />
              </div>

              {/* Mess Filter */}
              <div className="filter-group">
                <label className="filter-label">
                  <FaUtensils />
                  <span>Mess</span>
                </label>
                <SelectPicker
                  data={hostelOptions.map((opt) => ({
                    label: opt,
                    value: opt,
                  }))}
                  onChange={setmessFilter}
                  value={messFilter}
                  cleanable={false}
                  searchable={false}
                  className="filter-select"
                />
              </div>

              {/* Transport Filter */}
              <div className="filter-group">
                <label className="filter-label">
                  <FaBus />
                  <span>Transport</span>
                </label>
                <SelectPicker
                  data={hostelOptions.map((opt) => ({
                    label: opt,
                    value: opt,
                  }))}
                  onChange={settransportFilter}
                  value={transportFilter}
                  cleanable={false}
                  searchable={false}
                  className="filter-select"
                />
              </div>
            </div>
          </div>

          {/* Students Table */}
          <div className="senior-students-table">
            {isLoading ? (
              <div className="loading-container">
                <Loader />
                <p>Loading student data...</p>
              </div>
            ) : (
              <EntranceTable
                listname={`${is_Senior ? "Senior" : "Junior"} Students List`}
                data={filteredStudents}
                navigateBaseUrl={
                  is_Senior ? `/admin/seniorStudent` : `/admin/juniorStudent`
                }
                setSortOrder={setSortOrder}
                sortOrder={sortOrder}
              />
            )}
          </div>
        </>
      ) : (
        <div className="no-permission">
          <FaExclamationTriangle />
          <h2>Access Denied</h2>
          <p>You don't have permission to access this section.</p>
        </div>
      )}
    </div>
  );
};

export default SeniorStudents;
